module.exports = __webpack_public_path__ + "img/20180815_150347_073.599ad833.jpg";